var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('title1',{staticStyle:{"margin-top":"30px"},attrs:{"type":"2","title":"故障自动化处理"}}),_c('div',{staticStyle:{"width":"666px","height":"375px","margin-top":"30px"}},[(_vm.showcdata)?_c('MyEcharts',{attrs:{"id":'zhinengyunwei3221',"options":_vm.cdata}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }